import { Button, Card, Dialog, FormControl, InputLabel, MenuItem, Stack, Tooltip, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import MonthChange from './MonthChange';
import LineChart from '../../../Components/Charts/LineChart';
import { AppColors } from '../../../Utils/helper/AppColors';
import _ from 'lodash';
import { InfoIcon } from '../../../Components/Icons/Icons';
import { Checkbox, DatePicker, Select } from 'antd';
import { FiCalendar } from 'react-icons/fi';
import { Popover } from '@mui/material';

import dayjs from 'dayjs';
import CustomInfoTooltip from '../../../Components/CustomInfoTooltip';
import { getColorSettings } from '../../../Utils/helper/commonUtils';
const { Option } = Select;
const { RangePicker } = DatePicker;

export default function LineGraphCard({
	value,
	minHeight,
	title,
	additionalFilters,
	values,
	showFilter,
	color,
	xAxisSpace = false,
	onDateRangeChange,
	tooltipTitle,
	placement,
}) {
	const [lineData, setLineData] = useState([]);
	const [labels, setLabels] = useState([]);
	const [filterType, setFilterType] = useState(7); // 7 days default
	const [customRange, setCustomRange] = useState([null, null]);
	const [openPicker, setOpenPicker] = useState(false);
	const [customLabel, setCustomLabel] = useState(''); // <-- add this

	const localSettingColors = getColorSettings();

	useEffect(() => {
		if (additionalFilters?.length > 0 && _.isArray(values)) {
			setLineData(
				values?.map((i) => {
					return {
						label: i?.name,
						data: _.isArray(i?.value) ? i?.value?.map((j) => j?.value) : [],
						backgroundColor: additionalFilters?.find((j) => j?.code == i?.name)?.barColor,
						borderColor: additionalFilters?.find((j) => j?.code == i?.name)?.color,
						borderWidth: 2,
						pointRadius: 4,
					};
				}),
			);
		} else {
			setLineData([
				{
					data: values?.map((i) => i?.value),
					borderColor: color,
					borderWidth: 3,
					pointRadius: 2,
				},
			]);
		}
	}, [additionalFilters, values]);

	useEffect(() => {
		if (additionalFilters?.length > 0 && _.isArray(values[0]?.value)) {
			setLabels(values[0]?.value?.map((i) => i?.name));
		} else {
			setLabels(values?.map((i) => i?.name));
		}
	}, [additionalFilters, values]);

	const chartData = {
		labels,
		datasets: lineData,
	};

	// Handle filter change
	const handleFilterChange = (event) => {
		// console.log('event', event);
		const val = event;
		setFilterType(val);
		if (val === 'custom') {
			setOpenPicker(true);
		} else {
			// Calculate from/to based on days
			setCustomLabel('');
			setOpenPicker(false);
			const to = dayjs().format('YYYY-MM-DD');
			const from = dayjs().subtract(val, 'day').format('YYYY-MM-DD');
			onDateRangeChange && onDateRangeChange({ from, to });
		}
	};

	// Handle custom range apply
	const handleCustomApply = () => {
		if (Array.isArray(customRange) && customRange[0] && customRange[1]) {
			setOpenPicker(false);
			const fromLabel = dayjs(customRange[0]).format('D MMM');
			const toLabel = dayjs(customRange[1]).format('D MMM');
			const label = `${fromLabel} - ${toLabel}`;
			setCustomLabel(label);
			setFilterType(label);
			onDateRangeChange &&
				onDateRangeChange({
					from: dayjs(customRange[0]).format('YYYY-MM-DD'),
					to: dayjs(customRange[1]).format('YYYY-MM-DD'),
				});
		}
	};

	// console.log('chartData', chartData);

	return (
		<Card sx={{ minHeight: '100%' }}>
			<Stack mb={2} direction="row" justifyContent="space-between" px={1} width={'100%'}>
				<Stack direction="row" alignItems="center" gap={1}>
					<Typography textAlign={'center'} fontFamily={'Poppins'} fontSize={14} fontWeight={600} lineHeight={'150%'}>
						{title}
					</Typography>

					{/* <InfoIcon size={16} color={localSettingColors.fontColor} /> */}

					<CustomInfoTooltip title={tooltipTitle} placement={placement} />
				</Stack>

				{
					showFilter && (
						<Stack>
							<Select
								// className="custom-select"
								value={filterType}
								onChange={handleFilterChange}
								onSelect={(val) => {
									if (val === 'custom') setOpenPicker(true);
								}}
								style={{
									// width: '75px',
									// height: '22px',
									// backgroundColor: AppColors.LIGHTEST_SHADE,
									color: localSettingColors.fontColor,
								}}
								dropdownStyle={{
									backgroundColor: localSettingColors.quinary,
								}}
								getPopupContainer={(trigger) => trigger.parentNode} 
							>
								<Option value={7}>Last 7 Days</Option>
								<Option value={15}> Last 15 Days</Option>
								<Option value="custom">Custom</Option>
								{/* {customLabel && <Option value="customRange">{customLabel}</Option>} */}
							</Select>
						</Stack>
					)
					// add filter here like 7 days , 15 days , custom filter
				}
			</Stack>
			<Stack mb={2} direction="row" alignItems="center" gap={2}>
				{value && (
					<Typography variant="subtitle1" fontSize={36} fontWeight={600}>
						{value}%
					</Typography>
				)}

				{/* <MonthChange title="conversation" change={10} effect="positive" /> */}
			</Stack>

			<LineChart yGrid grid data={chartData} xAxisSpace={xAxisSpace} width="100%" height={300} />
			<Dialog
				open={openPicker}
				onClose={() => setOpenPicker(false)}
				PaperProps={{
					sx: {
						width: '603px',
						height: '400px',
					},
				}}
			>
				<Stack p={2} spacing={2}>
					<RangePicker
						value={customRange}
						onChange={(val) => setCustomRange(val || [null, null])}
						format="YYYY-MM-DD"
						// Remove minDate if you want to allow past dates, otherwise use minDate={dayjs()}
						// minDate={dayjs()}
						// defaultValue={[
						//     details?.scheduling?.startDate ? dayjs(details?.scheduling?.startDate, 'YYYY-MM-DD') : null,
						//     details?.scheduling?.endDate ? dayjs(details?.scheduling?.endDate, 'YYYY-MM-DD') : null,
						// ]}
						
						getPopupContainer={(node) => node.parentNode}
						style={{ width: '100%' }}
						suffixIcon={<FiCalendar color={AppColors.LIGHT1} size={18} />}
						disabledDate={current => current && current > dayjs().endOf('day')}

					/>
					<Button variant="contained" color="info" onClick={handleCustomApply} disabled={!customRange[0] || !customRange[1]}>
						Apply
					</Button>
				</Stack>
			</Dialog>
		</Card>
	);
}
